module.exports = __webpack_public_path__ + "static/scheduling-25f2d12b1db67bfa8834c27e8ab8bc99.svg";